export default "__VITE_ASSET__w4pGVgaB__"